























	import Vue, { PropType } from 'vue';
    import _termine from '../../services/endpoints/termine';

    export default Vue.extend({
        name: "KommentarComp",
		props: {
			termin: Object as PropType<any>,
			role: Number
		},
        data: () => ({
            savedText: '',
            text: '',
            lastChange: 0,
        }),
        computed: {
            rules: function() {
                return [
                    (v: string) => (!v || v.length <= 1000) || 'Bitte halte dich kurz ;)'
                ];
            },
            isDirty: function(): boolean {
                return !(this.text === this.savedText);
            }
        },
        methods: {
            saveText: async function(): Promise<void> {
                if (this.text.length <= 1000) {
                    await _termine.saveText(this.termin.id, this.text);
                    this.savedText = this.text;
                }
            }
        },
        created: async function(): Promise<void> {
            this.text = await _termine.getText(this.termin.id);
            this.savedText = this.text;
        },
        watch: {
            text: function(): void {
                this.lastChange = Date.now();
                const currentChange = this.lastChange;
                // eslint-disable-next-line @typescript-eslint/no-this-alias
                const that = this;
                setTimeout(function() {
                    if (currentChange === that.lastChange && that.isDirty) {
                        that.saveText();
                    }
                }, 2000)
            }
        },
        beforeDestroy: function(): void {
            if (this.isDirty) {
                this.saveText();
            }
        }
    })
